import { render, staticRenderFns } from "./centerPanel.vue?vue&type=template&id=f8c2df4c"
import script from "./centerPanel.vue?vue&type=script&lang=js"
export * from "./centerPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports